import React from "react";
import "./Footer.css";

const Footer=()=> {
    return (
        <div className="footer-wrapper">
            <div className="Footer-contents">
                <span className="footer-text">
                    Copyright ©︎ 2024 AoyamaTaro All Rights Reserved.
                </span>
            </div>
        </div>
    );
}

export default Footer;